import { ProductEnumDTO } from "features/shared/enums/dynamic/ProductEnumDTO";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";
import React from "react";

type Props = {
  product: ProductEnumDTO;
};

const ProductInfoSubDialog = ({ product }: Props) => {
  //translations
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "productInfoSubDialog");

  // render
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: product.description ?? tLabels("descriptionUndefined"),
      }}
      className="p-4"
    />
  );
};

export default ProductInfoSubDialog;
